(function () {
    'use strict';

    angular
        .module('app')
        .controller('dataCard', dataCard);

    dataCard.$inject = ['$scope', 'dataCardService', '$injector', '$q', '$timeout', '$mdDialog', '$rootScope', '$state', '$filter', 'loginService', '$location', '$window'];

    function dataCard($scope, dataCardService, $injector, $q, $timeout, $mdDialog, $rootScope, $state, $filter, loginService, $location, $window) {

        /* jshint validthis:true */
        var vm = this;
        vm.dataCardDropdownTitle = loginService.resourceStrings["AVAILABLE_DATA_CARDS"] + ":"; // "Available Data Cards:";
        vm.inputModel = {};
        vm.inputModelCopy = {}; // Duplicate copy of inputModel
        vm.dataCardDirty = false;
        vm.memoActive = false;
        vm.froalaEditor = {};
        vm.memoDirty = false;
        vm.dirtyInputs = {};
        vm.schemaEditColorByState = {};
        vm.reloadGrid = true;
        vm.updateDocument = false;
        vm.updateDocumentEnabled = false;
        vm.loginService = loginService;
        dataCardService.memoInfo.data = "";
        vm.isWindows = bowser.windows;
        vm.resetValue = false;
        var gridDataService = $injector.get("gridDataService");
        switch (gridDataService.currentFocus) {
            case "dd":
                vm.gridRecords = [];
                break;
            default:
                vm.gridRecords = gridDataService.data;
                break;
        }

        vm.testMyButton = function () {
            console.log(vm.inputModel);
        }

        //library card service for binding purposes
        vm.dataCardService = dataCardService;
        vm.thumbnailMessage = loginService.resourceStrings["THUMBNAIL_ERROR"];

        //select first tab as default
        vm.dataCardService.activeTab = 0;
        //keeps track of the current record in relation to the grid
        vm.recordIndex = vm.gridRecords.indexOf(gridDataService.selectedRows[0]);
        if (vm.recordIndex == -1 && gridDataService.currentFocus != 'dd') {
            $state.go('layout.results.grid');
            return;
        }

        //set the current record at the service level so it knows which record to get
        vm.dataCardService.currentRecord = gridDataService.selectedRows[0];
        $scope.selectedRecord = gridDataService.selectedRows[0];

        $timeout(function () {
            //get's the current library card from the server
            dataCardService.getStructure().then(function () {
                //set the current library card id locally for binding
                vm.currentDataCardId = dataCardService.currentDataCardId;
                vm.dataCardService.dataCardMode = vm.dataCardService.dataCardModeSave = vm.dataCardService.const_DataCardDataMode_View;

                //get the data for the current record
                getRecordData();
            });
        }, 500);


        //changes the current library card
        vm.dataCardChanged = function () {

            //cleanup
            cleanUp().then(function () {
                //set the card in then service to the chosen one
                dataCardService.currentDataCardId = vm.currentDataCardId;

                //change the card
                dataCardService.changeCard().then(function () {
                    //get the record data
                    getRecordData();
                });
            }, function () {
                //set it back to original library card if user cancels save prompt.
                vm.currentDataCardId = dataCardService.currentDataCardId
            });
        }


        vm.updateDocumentModeChange = function () {
            // Call the endpoint to get the data card data with the flag set for updateDocument set or unset.
            getRecordData(true).then(function () {
                sanityCheck();
            });
        }


        // local method to get the current record's data
        function getRecordData(updateDocumentChanged) {

            var deferred = $q.defer();
            // State of the updateDocument checkbox is passed in, which determines which WebAPI endpoint to call, either Edit or UpdateDocument.
            vm.dataCardService.getCurrentRecordData(vm.updateDocument, vm.memoDirty).then(function () {

                var currentInputModel;
                if (updateDocumentChanged) {
                    //save the state of the current inputModel
                    currentInputModel = angular.copy(vm.inputModel, currentInputModel);
                }

                //construct the model which will be bound to the inputs
                vm.schemaEditColorByState = dataCardService.schemaEditColorByState;

                vm.updateDocumentEnabled = dataCardService.updateDocumentEnabled;

                // ---
                // Preserve the current data card mode, and set the new data card mode: view, edit, update document
                //
                // If there was a switch from one mode to another, ensure that data entered into fields isn't overwritten.
                // For example, switching from "Edit" to "Update Document" should not overwrite edited field values.
                if ((vm.dataCardService.dataCardMode === vm.dataCardService.const_DataCardDataMode_View &&
                    vm.dataCardService.dataCardModeSave !== vm.dataCardService.const_DataCardDataMode_UpdateDocument) ||
                    (vm.dataCardService.dataCardMode === vm.dataCardService.const_DataCardDataMode_Edit &&
                        vm.dataCardService.dataCardModeSave !== vm.dataCardService.const_DataCardDataMode_UpdateDocument)) {
                    var record = vm.dataCardService.currentRecordData.docRecResults.TableRecords[0];
                    for (var prop in record) {
                        //if the property is null set it to blank
                        vm.inputModel[prop] = record[prop] === null ? "" : record[prop];
                    }
                }
                else if (vm.dataCardService.dataCardMode === vm.dataCardService.const_DataCardDataMode_Edit &&
                    vm.dataCardService.dataCardModeSave === vm.dataCardService.const_DataCardDataMode_UpdateDocument) {
                    // If switching from "update document" mode to "edit" mode, restore the original values for all
                    // _now_ disabled fields and mark them as not dirty
                    var record = vm.dataCardService.currentRecordData.docRecResults.TableRecords[0];
                    for (var prop in record) {
                        console.log(prop);
                        if (vm.dataCardService.currentRecordData.schemaEditable[prop] === false) {
                            // console.debug(prop + " (old) " + record[prop]);
                            // console.debug(prop + " (new) " + vm.inputModelCopy[prop]);
                            // Set the original value
                            vm.inputModel[prop] = record[prop] === null ? "" : record[prop];
                            // Make record not dirty
                            delete vm.dirtyInputs[prop];
                        }
                    }
                }


                if (updateDocumentChanged) {
                    //use the currentInputModel if available
                    if (currentInputModel) {
                        var keys = Object.keys(vm.schemaEditColorByState);
                        angular.forEach(keys, function (key) {
                            if (vm.schemaEditColorByState[key] != "#ffff") {
                                currentInputModel[key] = vm.inputModel[key];
                            }
                        });
                        vm.inputModel = currentInputModel;
                    }
                }
                else {
                    //make a copy of the inputmodel to track changes
                    angular.copy(vm.inputModel, vm.inputModelCopy);
                }

                deferred.resolve();
            }, function () {
                console.log('getRecordData failed.');
            });
            return deferred.promise;
        }

        // =======================================================
        // Handle Autofill - Begin
        // =======================================================

        var handleAutofill = function(schemaId, value, maxFieldLength) {
            console.log("handling autofill for", schemaId);
            if (value != null && value.length > 0) {
                var fieldsPacket = dataCardService.fieldsPacket;
                // Walk the fields packet.
                var count = fieldsPacket.fieldsPacket.length;
                console.log("fieldsPacket count:", count);
                for (var i = 0; i < count; i++) {
                    var fieldPacket = fieldsPacket.fieldsPacket[i];
                    if (fieldPacket.schemaId === schemaId) {
                        // If current field length is smaller then enterd text, truncate it.
                        console.log("Truncating input to maximinm field size: ", maxFieldLength);
                        if (maxFieldLength !== -1 && value.length > maxFieldLength) {
                            vm.inputModel[schemaId] = value.substring(0, maxFieldLength);
                        }

                        // If the current field has autofill fields, then call the server.
                        if (fieldPacket.autofillSchemaIds != null) {

                            // Get all of the parent values, and put this one on the end.
                            var values = getParentValues(schemaId);
                            values.push(value);

                            dataCardService.getAutofillValues(schemaId, values).then(function (autofillPackets) {
                                // Walk the items.
                                var autofillCount = autofillPackets.length;
                                for (var j = 0; j < autofillCount; j++) {
                                    var autofillPacket = autofillPackets[j];
                                    // Update value.
                                    console.log("setting auto fill value:", autofillPacket.name.value);
                                    vm.inputModel[autofillPacket.name.schemaId] = autofillPacket.name.value;
                                    
                                    // Reversed.
                                    // Mark as dirty.
                                    //vm.inputChanged(autofillPacket.name.schemaId, autofillPacket.name.value);
                                    vm.inputChanged(autofillPacket.name.value, autofillPacket.name.schemaId);
                                }
                            });
                        }
                        break;
                    }
                }
            }
        }

        // =======================================================
        // Handle Autofill - End
        // =======================================================


        // =======================================================
        // Blank Children - Begin
        // =======================================================

        var blankChild = function (fieldsPacket, initialSchemaId, schemaId, bBlankAutofill) {
            // Walk the fields packet.
            var count = fieldsPacket.fieldsPacket.length;
            for (var i = 0; i < count; i++) {
                var fieldPacket = fieldsPacket.fieldsPacket[i];
                if (fieldPacket.schemaId == schemaId) {
                    // Maybe, blank it's autofill fields
                    if (bBlankAutofill && fieldPacket.autofillSchemaIds != null) {
                        var autofillCount = fieldPacket.autofillSchemaIds.length;
                        for (var j = 0; j < autofillCount; j++) {
                            var autofillSchemaId = fieldPacket.autofillSchemaIds[j];
                            // Update value.
                            vm.inputModel[autofillSchemaId] = "";
                            // Mark as dirty.
                            vm.inputChanged("", autofillSchemaId);
                        }
                    }

                    // If the current field has children, ...
                    if (fieldPacket.childSchemaIds != null) {
                        // Walk the children.
                        var childCount = fieldPacket.childSchemaIds.length;
                        for (var k = 0; k < childCount; k++) {
                            var childSchemaId = fieldPacket.childSchemaIds[k];

                            //blankChild(fieldsPacket, initialSchemaId, childSchemaId);

                            // Update value.
                            vm.inputModel[childSchemaId] = "";

                            // Mark as dirty.
                            vm.inputChanged("", childSchemaId);

                            blankChild(fieldsPacket, initialSchemaId, childSchemaId, true);
                        }
                    }
                    break;
                }
            }
        }

        var blankChildren = function (schemaId, value) {
            var fieldsPacket = dataCardService.fieldsPacket;
            var bBlankAutofill = false;
            if (value == null || value.length < 1)
                bBlankAutofill = true;
            blankChild(fieldsPacket, schemaId, schemaId, bBlankAutofill);
        }

        // =======================================================
        // Blank Children - End
        // =======================================================


        //handles input changes
        vm.inputChanged = function (value, id, obj) {
            console.log("input changed", value, id);
            if (obj) {
                if (obj.schemaModel.baseFieldDefinition.fieldType === 4) {
                    var width = obj.schemaModel.baseFieldDefinition.width;
                    var precision = obj.schemaModel.baseFieldDefinition.precision;

                    if (!validateDouble(value, width, precision)) {
                        //console.log(value.substring(0, value.length - 1));
                        vm.inputModel[obj.schemaModel.schemaDefinition.id] = value.substring(0, value.length - 1);
                    }
                }
            }

            if (vm.bProcessingInputChanged)
                return;

            if (value == undefined) {
                return;
            }

            vm.bProcessingInputChanged = false;

            // Color change to background when a field is modified.  Change from white to a burnt orange.
            $timeout(function () {
                //check the input model copy to see if the individual input has changed from the original value
                if (vm.inputModelCopy[id] == vm.inputModel[id] || value == "++++##filtering##++++") {
                    delete vm.dirtyInputs[id];
                    if (isEmpty(vm.dirtyInputs)) {
                        vm.dataCardDirty = false;
                    }
                    if (value !== "++++##filtering##++++") {
                        var maxFieldLength = -1;
                        if (obj) {
                            maxFieldLength = obj.schemaModel.baseFieldDefinition.width;
                        }
                        handleAutofill(id, value, maxFieldLength);
                    }
                }
                else {
                    vm.dataCardDirty = true;
                    if (!vm.dirtyInputs[id]) {
                        vm.dirtyInputs[id] = true;
                        console.debug('-----> dirty input: '+vm.dataCardService.schemaModels[id].schemaDefinition.displayName);

                        $timeout(function () {
                            var maxFieldLength = -1;
                            if (obj) {
                                maxFieldLength = obj.schemaModel.baseFieldDefinition.width;
                            }
                            handleAutofill(id, value, maxFieldLength);
                        }, 100);
                    }
                }
                if (value !== "++++##filtering##++++") {
                    //sanity check
                    var maxFieldLength = -1;
                    if (obj) {
                        maxFieldLength = obj.schemaModel.baseFieldDefinition.width;
                    }
                    handleAutofill(id, value, maxFieldLength);
                    sanityCheck(id);
                }

            }, 100);
        }

        function sanityCheck(inputIdOfChanged) {
            //console.log(vm.inputModel);
            //console.log(vm.inputModelCopy);
            //stringify the object and check for changes, this will allow the save button to be disabled if changes are reverted
            if (JSON.stringify(vm.inputModel) != JSON.stringify(vm.inputModelCopy) || vm.memoDirty) {
                vm.dataCardDirty = true;
                blankChildren(inputIdOfChanged);
            }
            else {
                vm.dirtyInputs = {};
                vm.dataCardDirty = false;
            }
        }

        function isEmpty(map) {
            for (var key in map) {
                if (map.hasOwnProperty(key)) {
                    return false;
                }
            }
            return true;
        }

        function validateDouble(number, len, precision) {
            var num_pieces = number.split(".");
            var num_length = number.length;

            if (number === ".") {
                return true;
            }


            // Generic number check
            if ((number == "") || (number < 0) || (isNaN(number))) {
                return false;
            }

            // Check decimal count
            if (num_pieces.length > 2) {
                return false;
            }

            // Check full length
            num_length -= (num_pieces.length == 2 && num_pieces[1].length <= 0) ? 1 : 0; // handle trailing decimal
            if (num_length > len) {
                return false;
            }

            // Check decimal places
            if ((num_pieces.length == 2) && (num_pieces[1].length > precision)) {
                return false;
            }

            //Check that integer part of the number doesn't exceed the total length minus the decimal part.
            if (num_pieces.length === 1 && num_pieces[0].length > len - (precision + 1)) {
                return false;
            }

            return true;
        }

        //handles memo changes
        vm.memoChanged = function () {
            vm.memoDirty = true;
            vm.dataCardDirty = true;
        }

        vm.tabChanged = function (index, tab) {
            vm.dataCardService.activeTab = index;
            tab.active = true;
            switch (tab.id) {
                case 11111:
                    if (dataCardService.currentDataCardId != "" && !dataCardService.gotMemo) {
                        vm.dataCardService.getMemo();
                    }
                    break;
                case 12222:
                    if (dataCardService.currentDataCardId != "") {
                        vm.dataCardService.getThumbnailAsPng();
                    }
                    break;

                default:
            }
        }

        //event handler for back button
        vm.backToGrid = function () {
            //handles checks for dirty and untagging, async call.
            vm.reloadGrid = false;
            $state.go("layout.results.grid");

        }

        //let's keep a record here to lookup correct values when saving.
        vm.restrictedItems = {};

        //gets restricted fields data for the selection box
        vm.getRestricted = function (schemaId) {
            var deferred = $q.defer();
            var options = [];
            dataCardService.getRestrictedValues(schemaId).then(function (items) {

                angular.forEach(items, function (item, key) {
                    if (item.name != "") {
                        options.push(item.name);
                    }
                });
                vm.restrictedItems[schemaId] = options;
                deferred.resolve(options);
            });
            return deferred.promise;
        };

        // =======================================================
        // Dropdown - Related Fields - Begin
        // =======================================================

        // Look for a schema id in the fields packet.
        // If found, return the parent's schema id and the current value.
        var getParentValue = function (fieldsPacket, schemaId) {
            // Walk the fields packet.
            var count = fieldsPacket.fieldsPacket.length;
            for (var i = 0; i < count; i++) {
                var fieldPacket = fieldsPacket.fieldsPacket[i];
                // If the current field has children, ...
                if (fieldPacket.childSchemaIds != null) {
                    // Walk the children.
                    var childCount = fieldPacket.childSchemaIds.length;
                    for (var j = 0; j < childCount; j++) {
                        var childSchemaId = fieldPacket.childSchemaIds[j];
                        // If the current child is the schema id that we are looking for, ...
                        if (childSchemaId == schemaId) {
                            // Return schemaId of the parent, and its current value.
                            return { schemaId: fieldPacket.schemaId, value: vm.inputModel[fieldPacket.schemaId] };
                        }
                    }
                }
            }
            // The requested schemaId was not found as a child in the entire fields packet.
            return null;
        };

        // Build an array of parent values.
        var getParentValues = function (schemaId) {
            var rtn = [];
            var fieldsPacket = dataCardService.fieldsPacket;
            var parentInfo = getParentValue(fieldsPacket, schemaId);
            while (parentInfo != null) {
                rtn.unshift(parentInfo.value);
                parentInfo = getParentValue(fieldsPacket, parentInfo.schemaId);
            }
            return rtn;
        }

        //gets restricted fields data for the selection box
        vm.getDropdownListValues = function (schemaId) {
            // look up the field in the datacard structure
            var parentValues = getParentValues(schemaId);
            vm.dataCardService.loading = true;
            var deferred = $q.defer();
            dataCardService.getDropdownListValues(schemaId, parentValues).then(function (items) {
                vm.dataCardService.loading = false;
                deferred.resolve(items);
            });
            return deferred.promise;
        };

        // =======================================================
        // Dropdown - Related Fields - End
        // =======================================================

        //changes record based on the button clicked
        vm.changeRecord = function (direction) {
            //call the cleanup method, will run async and wait for the cleanup to take its course.
            cleanUp().then(function () {
                console.log("cleanup done");
                $timeout(function () {
                    //figure out if it's next or previous
                    var numVar = direction == "next" ? 1 : -1;
                    //set the selected record locally
                    $scope.selectedRecord = vm.gridRecords[vm.recordIndex + numVar];
                    //notify scope listener about the record change
                    gridDataService.selectedRecordChanged($scope.selectedRecord);
                    //set the service's current record
                    dataCardService.currentRecord = $scope.selectedRecord;
                    //update the local index
                    vm.recordIndex = vm.recordIndex + numVar;
                    //get the record data
                    // Reset to the default data card mode
                    vm.dataCardService.dataCardMode = vm.dataCardService.dataCardModeSave = vm.dataCardService.const_DataCardDataMode_View;
                    vm.updateDocument = false;
                    console.log("Getting new record");
                    getRecordData().then(function () {
                        console.log("Done getting new record");
                        vm.resetValue = true;
                        //check the tab we're in to get that tab's data
                        var thisTab = vm.dataCardService.tabs[vm.dataCardService.activeTab];
                        switch (thisTab.id) {
                            //memo tab
                            case 11111:
                                vm.dataCardService.getMemo();
                                break;
                            case 12222:
                                vm.dataCardService.getThumbnailAsPng();
                                break;
                        }
                    });
                });

            }, function () {
                //console.log('returned to record');
            });
        }

        //to save record changes
        vm.hasBeenSaved = false;
        vm.saveChanges = function () {
            vm.dataCardService.loading = true;
            var deferred = $q.defer();
            //need to have a delay in order for inputs to do their due checks.
            $timeout(function () {
                for (var key in vm.inputModel) {
                    if (vm.restrictedItems[key]) {
                        angular.forEach(vm.restrictedItems[key], function (item) {

                            //check to make sure that if it's a restricted list, that the value is an option
                            var valueInList = false;
                            angular.forEach(vm.restrictedItems[key], function (item) {
                                if (item.toLowerCase() == vm.inputModel[key].toLowerCase()) {
                                    vm.inputModel[key] = item;
                                    valueInList = true;
                                }
                            });

                            //if the value is not in the list of options, blank it out.
                            if (!valueInList) {
                                vm.inputModel[key] = "";
                            }

                        });
                    }
                }
                console.log("saving fields for:", dataCardService.currentRecord.SCHEMA_S_LONGNAME);
                dataCardService.saveFields(vm.inputModel).then(function () {
                    console.log("Fields saved for:", dataCardService.currentRecord.SCHEMA_S_LONGNAME);
                    //clone the inputModel object again
                    angular.copy(vm.inputModel, vm.inputModelCopy);
                    vm.hasBeenSaved = !vm.hasBeenSaved;

                    // Save with Update Document
                    if (vm.updateDocument === true) {
                        console.log("Update Document is enabled, getting record data for:", dataCardService.currentRecord.SCHEMA_S_LONGNAME);
                        vm.dataCardService.loading = true;
                        getRecordData().then(function () {
                            var fieldValues = {};

                            // Go through each field on the data card.  If field is "dirty", save it to a new list that will be 
                            // passed down to ACS.
                            var extractedDirtyInputCount = 0;
                            angular.forEach(dataCardService.schemaModels, function (item, key) {
                                var schemaId = item.baseFieldDefinition.schemaID;
                                if (vm.dirtyInputs[schemaId] == true) {
                                    fieldValues[item.baseFieldDefinition.fieldID] = vm.inputModel[schemaId];

                                    // Check for extracted fields and increase count -  see below
                                    if (vm.dataCardService.schemaModels[schemaId].baseFieldDefinition.bExtracted === true) {
                                        extractedDirtyInputCount++;
                                    }
                                }
                            });
                            console.debug('extractedDirtyInputCount = ' + extractedDirtyInputCount);

                            // If the number of dirty fields that are also extracted is greater than zero, proceed
                            // with Update Document.
                            if (extractedDirtyInputCount > 0) {
                                ////////////////////////////////////////
                                // Update Document - Data Card
                                // 
                                var libraryId = (dataCardService && dataCardService.currentRecord && dataCardService.currentRecord.SCHEMA_S_LIBID);

                                console.log("Performing update doc for:", dataCardService.currentRecord.SCHEMA_S_LONGNAME);
                                dataCardService.UpdateDocument(fieldValues,
                                    dataCardService.currentRecord.SCHEMA_S_LONGNAME,
                                    dataCardService.currentRecord.SCHEMA_S_SRCDB,
                                    dataCardService.currentRecord.SCHEMA_S_FILEID,
                                    dataCardService.currentRecord.SCHEMA_S_MAJREV,
                                    dataCardService.currentRecord.SCHEMA_S_MINREV,
                                    libraryId
                                ).then(function () {
                                    console.log("Update Document done");
                                    vm.dataCardDirty = false;
                                    vm.dirtyInputs = {};
                                    finishUp().then(function () {
                                        deferred.resolve();
                                    });


                                }, function (response) {
                                    vm.dataCardDirty = true;
                                    deferred.reject(response);
                                });
                            }
                            else {
                                finishUp().then(function () {
                                    vm.dirtyInputs = {};
                                    deferred.resolve();
                                });
                            }
                        });
                    }
                    else {
                        // Clear out the dirty Inputs
                        finishUp().then(function () {
                            vm.dirtyInputs = {};
                            deferred.resolve();
                        });
                    }

                    function finishUp() {
                        var def = $q.defer();
                        // Remove the backquote from the fields
                        angular.forEach(dataCardService.schemaModels, function (item, key) {
                            var schemaId = item.baseFieldDefinition.schemaID;
                            if (vm.inputModel[schemaId] === '`') {
                                vm.inputModel[schemaId] = '';
                            }
                        });


                        if (vm.memoDirty) {
                            dataCardService.saveMemo().then(function () {
                                getRecordData().then(function () {
                                    vm.dataCardDirty = false;
                                    vm.memoDirty = false;
                                    gridDataService.updateGridRecord(dataCardService.currentRecord);
                                    def.resolve();
                                });

                            });
                        }
                        else {
                            vm.dataCardDirty = false;
                            getRecordData().then(function () {
                                gridDataService.updateGridRecord(dataCardService.currentRecord);
                                def.resolve();
                            });
                        }

                        
                        return def.promise;
                    }
                }, function () {
                    deferred.reject();
                })
            }, 750);
            return deferred.promise;
        }

        var funcToCancelLocationChangeStartHook = $rootScope.$on('$locationChangeStart', function (event, newUrl) {
            //console.log("datacard: $locationChangeStart: newUrl: " + newUrl);

            // After the real newUrl, we get a 2nd call back to the datacard.
            if (newUrl.indexOf("#/datacard") > 0)
                return;

            vm.locationChange = newUrl;
            //funcToCancelLocationChangeStartHook();
            if (newUrl.indexOf("?fileId=") > -1 || newUrl.indexOf("?listId=") > -1)
                $rootScope.dataCardLocationChange = newUrl;
        });

        //intercepts a state change for cleanup needs to be done
        var intercept = $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
            //console.log("datacard: $stateChangeStart: toState: " + toState.name);
            //prevent the state transition as long as a token refresh has not failed.          
            if (!loginService.failedRefresh) {
                event.preventDefault();
                //clean up
                cleanUp().then(function () {
                    //unsubscribe to broadcast
                    intercept();

                    funcToCancelLocationChangeStartHook(); // 

                    if (vm.locationChange != null) {
                        if (vm.locationChange.indexOf("?fileId=") > -1 || vm.locationChange.indexOf("?listId=") > -1) {
                            //$location.path($location.url(vm.locationChange).hash()); //Go to page they're interested in
                            //$location.url(vm.locationChange);
                            //$location.path(vm.locationChange);
                            $window.location = vm.locationChange;
                            return; // PAUL
                        }
                    }

                    //go to the originally intended page
                    $state.go(toState.name).then(function () {
                        if (vm.reloadGrid) {
                            gridDataService.reloadGrid();
                        }
                        vm.reloadGrid = true;
                        //$scope.onHide();
                    });

                }, function () {
                    //console.log('returned to record');
                });
            }

        });

        //handles saving and untagging
        var cleanUp = function () {
            //defer the call
            var deferred = $q.defer();
            //untag method declaration
            var unTag = function () {
                var deferred = $q.defer();
                //untag record
                vm.dataCardService.unTag().then(function () {
                    deferred.resolve();
                });

                return deferred.promise;
            }

            vm.showThumbnailMessage = false;

            //check if the library card is dirty, prompt for save changes if true
            if (vm.dataCardDirty) {
                promptToSave().then(function () {
                    //untag the records after a response
                    unTag().then(function () {
                        //clear the dirty inputs
                        vm.dirtyInputs = {};
                        deferred.resolve();
                    });
                }, function () {
                    deferred.reject();
                })
            }
            //otherwise proceed to untag
            else {
                unTag().then(function () {
                    //clear the dirty inputs
                    vm.dirtyInputs = {};
                    deferred.resolve();
                });
            }

            //return a promise
            return deferred.promise;
        }

        var promptToSave = function (ev) {
            var deferred = $q.defer();
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/datacard/templates/savechanges.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false
            })
                .then(function (answer) {
                    switch (answer) {
                        case "save":
                            console.log("save selected");
                            vm.saveChanges().then(function () {
                                gridDataService.updateGridRecord()
                                deferred.resolve();
                            });
                            break;
                        case "continue":
                            vm.dataCardDirty = false;
                            vm.memoDirty = false;
                            deferred.resolve();
                            break;
                    }
                }, function () {
                    //cancel
                    deferred.reject();
                });
            return deferred.promise;
        };

        vm.datePicked = function (id, value) {
            //console.log("datacard datePicked id:" + id + ", value:" + value)
            if (value) {
                if (value.onDateSearchValue) {
                    var tmp = "";
                    //// DATEFMTWND - Convert from whatever "Local" came out of the date picker to our local.
                    //if (dataCardService.dateFormat == dataCardService.const_DateFormatWindows) {
                    //    tmp = dataCardService.localDateStringToStd(value.onDateSearchValue);
                    //    console.log("datacard datePicked value.onDateSearchValue:" + value.onDateSearchValue + ", tmp:" + tmp);
                    //}
                    //else {
                    tmp = value.onDateSearchValue;
                    //}
                    vm.inputModel[id] = tmp; // value.onDateSearchValue;
                }
                else
                    vm.inputModel[id] = "";
            }
            else {
                vm.inputModel[id] = "";
            }
            vm.inputChanged(value, id);
        }

        //backspace intercept
        var rx = /INPUT|SELECT|TEXTAREA/i;
        var backToGrid = function (e) {

            if (e.which == 8) { // 8 == backspace
                if (!rx.test(e.target.tagName) || e.target.disabled || e.target.readOnly) {
                    if (!angular.element(e.target).hasClass('froala-view')) {
                        e.preventDefault();
                        //always unbind the event
                        $(document).unbind("keydown keypress", backToGrid);
                        vm.reloadGrid = false;
                        $state.go('layout.results.grid');
                    }
                }
            }
        }
        $(document).bind("keydown keypress", backToGrid);

        $scope.$on('$destroy', function () {
            $(document).unbind("keydown keypress", backToGrid);
        })

        //controller for dialog
        function DialogController($scope, $mdDialog, loginService) {
            $scope.loginService = loginService;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.answer = function (answer) {
                $mdDialog.hide(answer);
            };
        }
    }

})();
